@if (toastService.toast(); as toast) {
  <div
    class="pointer-events-none fixed inset-x-0 bottom-6 z-[70] flex justify-center px-4 sm:justify-end sm:px-6"
  >
    <div
      class="toast-enter pointer-events-auto flex items-center gap-3 rounded-full bg-forest py-3 pr-4 pl-3 text-cream shadow-xl ring-1 ring-black/5"
    >
      <span
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold text-forest"
      >
        <app-icon name="check" svgClass="h-4 w-4" [strokeWidth]="2.5" />
      </span>
      <p class="text-sm font-medium">{{ toast.message }}</p>
      <button
        type="button"
        class="cursor-pointer ml-1 shrink-0 text-cream/60 transition hover:text-cream"
        (click)="toastService.hide()"
        aria-label="Dismiss"
      >
        <app-icon name="x" svgClass="h-4 w-4" />
      </button>
    </div>
  </div>
}
